document.addEventListener("DOMContentLoaded", function() {
      (function(window, document) {
        var lazyLoad = function() {
          var lazyImages = [].slice.call(document.querySelectorAll("img.lazyload"));
          if ("IntersectionObserver" in window) {
            let imageObserver = new IntersectionObserver(function(entries, observer) {
              entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                  let image = entry.target;
                  image.src = image.dataset.src;
                  image.classList.remove("lazyload");
                  imageObserver.unobserve(image);
                }
              });
            });
            lazyImages.forEach(function(image) {
              imageObserver.observe(image);
            });
          } else {
            var lazyLoadThrottleTimeout;
            function lazyload() {
              if (lazyLoadThrottleTimeout) clearTimeout(lazyLoadThrottleTimeout);
              lazyLoadThrottleTimeout = setTimeout(function() {
                var scrollTop = window.pageYOffset;
                lazyImages.forEach(function(img) {
                  if (img.offsetTop < (window.innerHeight + scrollTop)) {
                    img.src = img.dataset.src;
                    img.classList.remove('lazyload');
                  }
                });
                if (lazyImages.length == 0) {
                  document.removeEventListener("scroll", lazyload);
                  window.removeEventListener("resize", lazyload);
                  window.removeEventListener("orientationChange", lazyload);
                }
              }, 20);
            }
            document.addEventListener("scroll", lazyload);
            window.addEventListener("resize", lazyload);
            window.addEventListener("orientationChange", lazyload);
          }
        };
        lazyLoad();
      })(window, document);
    });